// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.filters-sidebar .dropdown-menu {
  padding-left: 10px;
  padding-right: unset;
  width: 290px; }

.filters-sidebar .dropdown-menu-show {
  opacity: .99; }

.filters-sidebar .container {
  padding-left: 5px; }
  .filters-sidebar .container .calendar-icon, .filters-sidebar .container .pin-marker-icon {
    margin-right: 10px; }
  .filters-sidebar .container .filter-1 {
    max-height: 20vh;
    overflow-y: auto;
    overflow-x: hidden; }
  .filters-sidebar .container .form-check {
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden; }
  .filters-sidebar .container .filter-date-range {
    flex-direction: row;
    display: flex;
    padding-bottom: 8px; }
    .filters-sidebar .container .filter-date-range .react-datepicker-wrapper {
      height: 2rem; }
  .filters-sidebar .container .filter-date-range-padding {
    padding-bottom: 190px; }
  .filters-sidebar .container .LM {
    padding-bottom: 0px; }

.filters-sidebar select.form-select, .filters-sidebar input[type='number'] {
  background-color: #12234f;
  color: #fff;
  border: unset;
  margin-bottom: 10px; }

.filters-sidebar input[type='number'] {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5; }

.filters-sidebar input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0; }

.filters-sidebar .form-check-label {
  color: #fff !important; }

.filters-sidebar .date-submit {
  display: flex;
  justify-content: center;
  align-items: center; }
  .filters-sidebar .date-submit .date-submit-btn {
    background-color: #002044;
    color: #fff;
    font-weight: bold; }

.filters-sidebar .filter-date-range-pick {
  max-width: 150px;
  margin-left: 10px; }

.filters-sidebar #mexico-scroll::-webkit-scrollbar {
  width: 0 !important; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/layout/Filters/styles.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACpBrD;EAEQ,kBAAkB;EAClB,oBAAoB;EACpB,YANK,EAAA;;AAEb;EAOQ,YAAY,EAAA;;AAPpB;EAUQ,iBAAiB,EAAA;EAVzB;IAaY,kBAAkB,EAAA;EAb9B;IAiBY,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB,EAAA;EAnB9B;IAuBY,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB,EAAA;EAzB9B;IA6BY,mBAAmB;IACnB,aAAa;IACb,mBAAmB,EAAA;IA/B/B;MAgCwC,YAAa,EAAA;EAhCrD;IAoCY,qBAAqB,EAAA;EApCjC;IAuCc,mBAAoB,EAAA;;AAvClC;EA2CQ,yBDpCiC;ECqCjC,WD/Ce;ECgDf,aAAa;EACb,mBAAmB,EAAA;;AA9C3B;EAiDQ,cAAc;EACd,WAAW;EACX,0CAA0C;EAC1C,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;;AAvDxB;EA0DM,wBAAwB;EACxB,SAAS,EAAA;;AA3Df;EA+DQ,sBAAmC,EAAA;;AA/D3C;EAmEQ,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;EArE3B;IAuEY,yBAAyB;IACzB,WAAW;IACX,iBAAiB,EAAA;;AAzE7B;EA8EQ,gBAAgB;EAChB,iBAAiB,EAAA;;AA/EzB;EAkFwC,mBAAoB,EAAA","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import '../../theme/_variables.scss';\n$width: 290px;\n\n.filters-sidebar{\n    .dropdown-menu{\n        padding-left: 10px;\n        padding-right: unset;\n        width: $width;\n    }\n    .dropdown-menu-show{\n        opacity: .99;\n    }\n    .container{\n        padding-left: 5px;\n\n        .calendar-icon, .pin-marker-icon{\n            margin-right: 10px;\n        }\n\n        .filter-1 {\n            max-height: 20vh;\n            overflow-y: auto;\n            overflow-x: hidden;\n        }\n\n        .form-check{\n            max-height: 300px;\n            overflow-y: auto;\n            overflow-x: hidden;\n        }\n\n        .filter-date-range {\n            flex-direction: row;\n            display: flex;\n            padding-bottom: 8px;\n            .react-datepicker-wrapper { height: 2rem }\n        }\n\n        .filter-date-range-padding {\n            padding-bottom: 190px;\n        }\n\n        .LM { padding-bottom: 0px }\n    }\n\n    select.form-select, input[type='number']{\n        background-color: $darkAndLightModeBackgroundColor;\n        color: $primaryFontColor;\n        border: unset;\n        margin-bottom: 10px;\n    }\n    input[type='number']{\n        display: block;\n        width: 100%;\n        padding: 0.375rem 2.25rem 0.375rem 0.75rem;\n        -moz-padding-start: calc(0.75rem - 3px);\n        font-size: 1rem;\n        font-weight: 400;\n        line-height: 1.5;\n    }\n    input[type='number']::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n\n    .form-check-label{\n        color: $primaryFontColor !important;\n    }\n\n    .date-submit {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        .date-submit-btn {\n            background-color: #002044;\n            color: #fff;\n            font-weight: bold;\n        }\n    }\n\n    .filter-date-range-pick {\n        max-width: 150px;\n        margin-left: 10px;\n    }\n\n    #mexico-scroll::-webkit-scrollbar { width: 0 !important }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
